'use strict';

var _jsx = require('@babel/runtime/helpers/jsx');
var React = require('react');
require('prop-types');
var classnames = require('classnames');
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a() {
      if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {
    value: true
  });
  Object.keys(n).forEach(function (k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function () {
        return n[k];
      }
    });
  });
  return a;
}
const RECOMMENDATIONS_HEART_EMPTY = 'recommendations-heart-empty';
const RECOMMENDATIONS_HEART_FULL = 'recommendations-heart-full';
const RECOMMENDATIONS_FULL_ICON = 'recommendations-full_icon';
const RECOMMENDATIONS_CHEVRON = 'recommendations-chevron';
const RECOMMENDATIONS_START_EMPTY = 'recommendations-star-empty';
const RECOMMENDATIONS_START_HALF = 'recommendations-star-half';
const RECOMMENDATIONS_START_FULL = 'recommendations-star-full';
const RECOMMENDATIONS_MELI_LOGO = 'recommendations-meli_logo';
const RECOMMENDATIONS_MELI_COINS = 'recommendations-meli_coins';
const RECOMMENDATIONS_CPG_ICON = 'recommendations-cpg_icon';
const RECOMMENDATIONS_CBT_ICON = 'recommendations-cbt_icon';
const RECOMMENDATIONS_BLACK_FRIDAY_ICON = 'recommendations-black-friday_icon';
const RECOMMENDATIONS_MELICHOICE_LOGO = 'recommendations-melichoice_logo';
const RECOMMENDATIONS_BUFLO_ICON_INFO = 'recommendations-buflo_icon_info';
const RECOMMENDATIONS_MSHOPS_LOGO = 'recommendations-mshops_logo';
const RECOMMENDATIONS_CLOCK_ICON = 'recommendations-clock_icon';
const RECOMMENDATIONS_STORE_ICON = 'recommendations-store_icon';
const RECOMMENDATIONS_FIRE_ICON = 'recommendations-fire_icon';
const RECOMMENDATIONS_BADGE_ICON = 'recommendations-badge_icon';
const RECOMMENDATIONS_INFO_ICON = 'recommendations-info_icon';
const RECOMMENDATIONS_APPAREL_ICON = 'recommendations-clothing_icon';
const RECOMMENDATIONS_BEAUTY_ICON = 'recommendations-beauty_icon';
const RECOMMENDATIONS_TOOLS_ICON = 'recommendations-tools_icon';
const RECOMMENDATIONS_SUPERMARKET_ICON = 'recommendations-super_icon';
const RECOMMENDATIONS_DECO_ICON = 'recommendations-furniture_icon';
var icons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RECOMMENDATIONS_APPAREL_ICON: RECOMMENDATIONS_APPAREL_ICON,
  RECOMMENDATIONS_BADGE_ICON: RECOMMENDATIONS_BADGE_ICON,
  RECOMMENDATIONS_BEAUTY_ICON: RECOMMENDATIONS_BEAUTY_ICON,
  RECOMMENDATIONS_BLACK_FRIDAY_ICON: RECOMMENDATIONS_BLACK_FRIDAY_ICON,
  RECOMMENDATIONS_BUFLO_ICON_INFO: RECOMMENDATIONS_BUFLO_ICON_INFO,
  RECOMMENDATIONS_CBT_ICON: RECOMMENDATIONS_CBT_ICON,
  RECOMMENDATIONS_CHEVRON: RECOMMENDATIONS_CHEVRON,
  RECOMMENDATIONS_CLOCK_ICON: RECOMMENDATIONS_CLOCK_ICON,
  RECOMMENDATIONS_CPG_ICON: RECOMMENDATIONS_CPG_ICON,
  RECOMMENDATIONS_DECO_ICON: RECOMMENDATIONS_DECO_ICON,
  RECOMMENDATIONS_FIRE_ICON: RECOMMENDATIONS_FIRE_ICON,
  RECOMMENDATIONS_FULL_ICON: RECOMMENDATIONS_FULL_ICON,
  RECOMMENDATIONS_HEART_EMPTY: RECOMMENDATIONS_HEART_EMPTY,
  RECOMMENDATIONS_HEART_FULL: RECOMMENDATIONS_HEART_FULL,
  RECOMMENDATIONS_INFO_ICON: RECOMMENDATIONS_INFO_ICON,
  RECOMMENDATIONS_MELICHOICE_LOGO: RECOMMENDATIONS_MELICHOICE_LOGO,
  RECOMMENDATIONS_MELI_COINS: RECOMMENDATIONS_MELI_COINS,
  RECOMMENDATIONS_MELI_LOGO: RECOMMENDATIONS_MELI_LOGO,
  RECOMMENDATIONS_MSHOPS_LOGO: RECOMMENDATIONS_MSHOPS_LOGO,
  RECOMMENDATIONS_START_EMPTY: RECOMMENDATIONS_START_EMPTY,
  RECOMMENDATIONS_START_FULL: RECOMMENDATIONS_START_FULL,
  RECOMMENDATIONS_START_HALF: RECOMMENDATIONS_START_HALF,
  RECOMMENDATIONS_STORE_ICON: RECOMMENDATIONS_STORE_ICON,
  RECOMMENDATIONS_SUPERMARKET_ICON: RECOMMENDATIONS_SUPERMARKET_ICON,
  RECOMMENDATIONS_TOOLS_ICON: RECOMMENDATIONS_TOOLS_ICON
});
var require$$0 = /*@__PURE__*/getAugmentedNamespace(icons);
var constants = require$$0;
var _path, _path2;

// Recommendations-fe Packages
const namespace = 'ui-recommendations-icon';

/* eslint-disable max-len */
const ClockIcon = _ref => {
  let {
    className = null
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    className: classnames(namespace, className),
    width: "10",
    height: "10",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, _path || (_path = /*#__PURE__*/_jsx("path", {
    d: "M8.59697 3.12537V7.62824L11.203 8.93165L10.6662 10.0049L7.39697 8.36978V3.12537H8.59697Z",
    fill: "rgba(0,0,0,0.55)",
    fillOpacity: "0.9"
  })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.799 8.00001C15.799 12.3078 12.3068 15.8 7.99897 15.8C3.69115 15.8 0.198975 12.3078 0.198975 8.00001C0.198975 3.69219 3.69115 0.200012 7.99897 0.200012C12.3068 0.200012 15.799 3.69219 15.799 8.00001ZM1.39897 8.00001C1.39897 11.6451 4.3539 14.6 7.99897 14.6C11.6441 14.6 14.599 11.6451 14.599 8.00001C14.599 4.35493 11.6441 1.40001 7.99897 1.40001C4.3539 1.40001 1.39897 4.35493 1.39897 8.00001Z",
    fill: "rgba(0,0,0,0.55)",
    fillOpacity: "0.9"
  })));
};
const ClockIconconMemo = /*#__PURE__*/React.memo(ClockIcon);
ClockIconconMemo.ICON_ID = constants.RECOMMENDATIONS_CLOCK_ICON;
var ClockIconconMemo$1 = ClockIconconMemo;
module.exports = ClockIconconMemo$1;
